<template>
  <!-- Główny kontener na całą stronę widoku archiwalnych pomiarów -->
  <div class="content-container">
    <!-- Panel filtrów po lewej stronie (np. daty, lokalizacja, itd.) -->
    <filters-archival-measurements />
    <div class="content-wrap">
      <!-- Pasek menu u góry strony -->
      <TopMenu />
      <!-- Główna sekcja z danymi archiwalnymi. Przekazujemy aktualny krok i stan wyniku -->
      <ArchivalMeasurements
        :step="step"
        :isResult="isResult"
        @nextStep="nextStep"
        @previousStep="previousStep"
        @clear="clear"
      />
    </div>
  </div>
</template>

<script>
import { ref, nextTick } from "vue";
import TopMenu from "../components/TopMenu.vue";
import ArchivalMeasurements from "../components/ArchivalMeasurements.vue";
import FiltersArchivalMeasurements from "../components/FiltersArchivalMeasurements.vue";
import { useArchivalStore } from "../stores/archival";
import { useRoute } from "vue-router";

export default {
  name: "ArchivalView",
  components: {
    TopMenu,
    ArchivalMeasurements,
    FiltersArchivalMeasurements,
  },
  setup() {
    const archival = useArchivalStore();  // Pinia store zarządzający krokami i stanem archiwalnych pomiarów
    const route = useRoute();             // Aktualna trasa (może zawierać meta np. result)

    // Reaktywne zmienne do kroku i stanu wyniku
    const step = ref(archival.step);
    const isResult = ref(archival.isResult);

    // Inicjalizacja – jeśli nie mamy meta.result, resetujemy do pierwszego kroku
    if (!route.meta.result) {
      archival.step = 1;
    } else {
      step.value = 3;     // Jeśli wchodzimy od razu na wynik, przeskocz do kroku 3
      nextStep();
    }

    // Przejście do następnego kroku – obsługuje logikę przełączania i resetowania wyniku
    async function nextStep() {
      if (step.value === 3) {
        archival.setResultState(false);
        isResult.value = false;
        await nextTick();
      }
      step.value = archival.nextStep();
      isResult.value = archival.isResult;
    }

    // Cofnięcie do poprzedniego kroku
    function previousStep() {
      step.value = archival.previousStep();
    }

    // Resetowanie całego procesu wyboru (np. po kliknięciu "Wyczyść")
    function clear() {
      archival.clear();
      step.value = archival.step;
      isResult.value = archival.isResult;
    }

    // Udostępnienie zmiennych i metod do template
    return {
      step,
      isResult,
      nextStep,
      previousStep,
      clear,
    };
  },
};
</script>

<style scoped>
/* Delikatne, jasne tło dla widoku */
.content-container {
  background-color: #f5f4f2;
}
</style>
